import { CLEAR_POST } from '../actions/posts'

const post = (state = {}, action:any = {}) => {
  switch (action.type) {
    case CLEAR_POST:
      state = {}
      break
  }
  return state
}

export default post
